import React from 'react'
import { Col } from 'react-bootstrap'

function DatosCodigoDeCupo (props) {
  const { codigo } = props

  const renderDatos = () => {
    const datos = codigo.map((c) => {
      return (
        c.valor && <h6 key={c.titulo}> {c.titulo}: <span style={{ fontWeight: 'bold' }}> {c.valor}</span></h6>
      )
    })

    return datos
  }

  return (
    <Col
      md={12}
      key={codigo}
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-around',
        alignItems: 'center',
        textAlign: 'center'
      }}
    >

      { renderDatos() }

    </Col>
  )
}

export default DatosCodigoDeCupo
